module.exports = __webpack_public_path__ + "media/images/icon_bgc_white-93024c8eeebc5684a2b33dc8a344fb85.png";